// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".app__CEVehicleQuestionsComponent__vehicleCustomEquipmentTable{margin-bottom:var(--GW-SPACING-2)}", "",{"version":3,"sources":["webpack://./../common/wni-ce/capabilities-react/wnice-capability-policychange-pa-react/components/CEVehicleQuestions/CEVehicleQuestionsComponent.module.scss"],"names":[],"mappings":"AAAA,+DACI,iCAAA","sourcesContent":[".vehicleCustomEquipmentTable {\n    margin-bottom: var(--GW-SPACING-2);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"vehicleCustomEquipmentTable": "app__CEVehicleQuestionsComponent__vehicleCustomEquipmentTable"
};
export default ___CSS_LOADER_EXPORT___;
